import { format, isValid, parseISO } from "date-fns";

/**
 * Formats a Date or ISO string for date picker display.
 * Used by DatePicker and similar picker components.
 */
export const formatDateForPicker = (
    date: Date | string | undefined,
    fmt: string,
): string => {
    if (date) {
        const newDate: Date =
            typeof date === "string"
                ? parseISO(date)
                : isValid(date)
                  ? date
                  : new Date();
        return format(newDate, fmt);
    }
    return "";
};

/**
 * Formats an ISO date string for table/display use.
 * Returns "--" for empty or invalid strings.
 */
export const formatIsoDate = (
    iso: string,
    fmt: string = "MM/dd/yyyy",
): string => {
    if (!iso) return "--";
    try {
        return format(parseISO(iso), fmt);
    } catch {
        return "--";
    }
};
